/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProximityZone } from './ProximityZone';
import {
    ProximityZoneFromJSON,
    ProximityZoneFromJSONTyped,
    ProximityZoneToJSON,
    ProximityZoneToJSONTyped,
} from './ProximityZone';

/**
 * 
 * @export
 * @interface VehicleZoneViolationEventCreate
 */
export interface VehicleZoneViolationEventCreate {
    /**
     * The client also provides the event id. This way we don't have to rely on timing based constraints. See `docs/backend/Offline-Synchronization.md` for details.
     * @type {string}
     * @memberof VehicleZoneViolationEventCreate
     */
    id: string;
    /**
     * The exact time the shock event occurred at. This has to be the time registered by the Elobox/App.
     * @type {Date}
     * @memberof VehicleZoneViolationEventCreate
     */
    time: Date;
    /**
     * The vehicle that was driven when the event was detected.
     * @type {string}
     * @memberof VehicleZoneViolationEventCreate
     */
    vehicleId: string;
    /**
     * The user that drove the vehicle when the event was detected.
     * @type {string}
     * @memberof VehicleZoneViolationEventCreate
     */
    userId?: string | null;
    /**
     * Minimum distance in cm
     * @type {number}
     * @memberof VehicleZoneViolationEventCreate
     */
    minimumDistanceCm: number;
    /**
     * Other vehicle's antenna B network ID, either this or `machine_id` must be set.
     * @type {number}
     * @memberof VehicleZoneViolationEventCreate
     */
    antennaBNetworkId?: number | null;
    /**
     * Other vehicle's machine ID, either this or `antenna_b_network_id` must be set.
     * @type {number}
     * @memberof VehicleZoneViolationEventCreate
     */
    machineId?: number | null;
    /**
     * Zone which was violated
     * @type {ProximityZone}
     * @memberof VehicleZoneViolationEventCreate
     */
    triggeredZone: ProximityZone;
}



/**
 * Check if a given object implements the VehicleZoneViolationEventCreate interface.
 */
export function instanceOfVehicleZoneViolationEventCreate(value: object): value is VehicleZoneViolationEventCreate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('minimumDistanceCm' in value) || value['minimumDistanceCm'] === undefined) return false;
    if (!('triggeredZone' in value) || value['triggeredZone'] === undefined) return false;
    return true;
}

export function VehicleZoneViolationEventCreateFromJSON(json: any): VehicleZoneViolationEventCreate {
    return VehicleZoneViolationEventCreateFromJSONTyped(json, false);
}

export function VehicleZoneViolationEventCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleZoneViolationEventCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'time': (new Date(json['time'])),
        'vehicleId': json['vehicleId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'minimumDistanceCm': json['minimumDistanceCm'],
        'antennaBNetworkId': json['antennaBNetworkId'] == null ? undefined : json['antennaBNetworkId'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'triggeredZone': ProximityZoneFromJSON(json['triggeredZone']),
    };
}

export function VehicleZoneViolationEventCreateToJSON(json: any): VehicleZoneViolationEventCreate {
    return VehicleZoneViolationEventCreateToJSONTyped(json, false);
}

export function VehicleZoneViolationEventCreateToJSONTyped(value?: VehicleZoneViolationEventCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'time': value['time'].toISOString(),
        'vehicleId': value['vehicleId'],
        'userId': value['userId'],
        'minimumDistanceCm': value['minimumDistanceCm'],
        'antennaBNetworkId': value['antennaBNetworkId'],
        'machineId': value['machineId'],
        'triggeredZone': ProximityZoneToJSON(value['triggeredZone']),
    };
}

